module.exports = __webpack_public_path__ + "media/character/character07-108be239.png";